import { useEffect as o } from "react";

var i = function i(t) {
  o(function () {
    var _t$current, _t$current3;

    var n = ((_t$current = t.current) === null || _t$current === void 0 ? void 0 : _t$current.querySelectorAll("a[href], button, textarea, input[type='text'], input[type='radio'], input[type='checkbox'], select"))[0],
        r = document.activeElement,
        c = function c(e) {
      var _t$current2;

      if (!n) {
        document.body.focus({
          preventScroll: !0
        });
        return;
      }

      e.target.tagName !== "BODY" && (((_t$current2 = t.current) === null || _t$current2 === void 0 ? void 0 : _t$current2.contains(e.target)) || (e.stopPropagation(), n === null || n === void 0 ? void 0 : n.focus({
        preventScroll: !0
      })));
    };

    return document.addEventListener("focus", c, {
      capture: !0,
      passive: !0
    }), document.activeElement && !((_t$current3 = t.current) !== null && _t$current3 !== void 0 && _t$current3.contains(r)) && r.blur(), function () {
      document.removeEventListener("focus", c, {
        capture: !0
      });
    };
  }, [t]);
};

export { i as useModalFocusLock };